import { CircularProgress, Divider, Typography } from '@mui/material'
import { Item } from './Item'
import { useIsFetching } from 'react-query'
import { useOrderStore } from 'modules/orders/store'
import { useRef } from 'react'
import { MainRef } from '../../Form'

export const ItemsList = () => {
  const mainRef: any = useRef<MainRef>(null)

  const form = useOrderStore.useForm()

  const isFetchingProductMargin = useIsFetching(['productMargin']) > 0
  const isFetchingOrderProductsPrice = useIsFetching(['orderProductsPrice']) > 0
  const isFetching = isFetchingProductMargin || isFetchingOrderProductsPrice

  // const sortedItems = useMemo(
  //   () =>
  //     form?.orderItems.sort(function (a: any, b: any) {
  //       if (a.sequence > b.sequence) {
  //         return 1
  //       }
  //       if (a.sequence < b.sequence) {
  //         return -1
  //       }
  //       return 0
  //     }),
  //   [form?.orderItems]
  // )

  return (
    <div
      ref={mainRef}
      style={{
        overflowY: 'auto',
        flex: 1
      }}
    >
      {!!isFetching && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0,0,0,0.3)'
          }}
        >
          <CircularProgress size={24} />
          <Typography sx={{ padding: { xs: 1 } }} variant="caption">
            Recalculando preços...
          </Typography>
        </div>
      )}
      {form?.orderItems?.length === 0 ? (
        <Typography sx={{ padding: { xs: 1 } }} variant="body2">
          Não há itens...
        </Typography>
      ) : (
        <>
          {form?.orderItems?.map((item: any) => (
            <div key={item.uuid}>
              <Item item={item} />
              <Divider />
            </div>
          ))}
        </>
      )}
    </div>
  )
}
